module.exports = __webpack_public_path__ + "static/media/DataLoadingAnimation.09089ad7.gif";